<template>
  <!-- 今日热榜配置管理 -->
  <div class="page_padding">
    <div class="page_content"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style></style>
<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/pages/index/views/hotList.vue